import { useContextFallback } from '@prenuvo/halo';

import { StudyGuardContext } from './study-guard.context';

export const useStudyGuard = () => useContextFallback(StudyGuardContext);
